// extracted by mini-css-extract-plugin
export var bubble = "_2k-0";
export var container = "_2k-f";
export var contrastBorder = "_2k-g";
export var greyOut = "_2k-2";
export var initialsColor0 = "_2k-3";
export var initialsColor1 = "_2k-4";
export var initialsColor10 = "_2k-d";
export var initialsColor11 = "_2k-e";
export var initialsColor2 = "_2k-5";
export var initialsColor3 = "_2k-6";
export var initialsColor4 = "_2k-7";
export var initialsColor5 = "_2k-8";
export var initialsColor6 = "_2k-9";
export var initialsColor7 = "_2k-a";
export var initialsColor8 = "_2k-b";
export var initialsColor9 = "_2k-c";
export var initialsWrapper = "_2k-1";
export var large = "_2k-l";
export var medium = "_2k-k";
export var mediumSmall = "_2k-j";
export var mediumSmallMedium = "_2k-o";
export var micro = "_2k-h";
export var small = "_2k-i";
export var tiny = "_2k-n";
export var xTiny = "_2k-m";